export default __webpack_public_path__ + "static/media/TickIconGreen.08eab7d7.svg";